<template>
    <div>
        <div id="main" v-show="!rotaAninhada">
            <div class="page">
                <div class="rotas vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('routes') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('promotor') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('cadastros') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('routes') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: 'rota-new' })"
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-three-quarters">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="rotas-table registry-wrapper">
                        <container-loader v-if="isLoading && !$store.getters.isLoading" />
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="allrotas"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="
                                    f.key != 'excluir' ? (f.key != 'inativos' ? $t(f.key) : '') : ''
                                "
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.delete"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        :icon-right="
                                            props.row.situacao == 1 ? 'delete ' : 'check'
                                        "
                                        position="is-left"
                                        v-tippy 
                                        :title="$t(props.row.situacao == 1 ? 'desativar' : 'reativar')"
                                    />
                                </div>
                                <div v-else-if="f.key == 'inativos'">
                                    <b-icon 
                                        v-if="props.row.inativos > 0"
                                        icon="alert-circle" 
                                        type="is-danger" 
                                        v-tippy 
                                        :title="$t('msg-registros-inativos-rotas')"
                                    />
                                </div>
                                <div v-else-if="f.key == 'criado-em'">
                                    {{ props.row[f.key] | moment('L') }}
                                </div>
                                <div v-else-if="f.key == 'titulo-da-rota'">
                                    <router-link
                                        :to="{
                                            name: 'rota-edit',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t('ativo') }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t('inativo') }}</b-tag
                                    >
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import RotaService from '@/services/promotor/RotaService.js';
import ContainerLoader from '@/components/content/loader/ContainerLoader.vue';

export default {
    components: {
        ContainerLoader,
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'rota-new' || to.name == 'rota-edit') {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    data() {
        return {
            rotaAninhada: false,
            allrotas: [],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 1, label: 'ativos' },
            service: new RotaService(this.$http, this.$router),
            fields: [
                { key: 'inativos', width: 5, sortable: false, sortFn: null },
                { key: 'codigo', width: '15%', sortable: false, sortFn: null },
                {
                    key: 'titulo-da-rota',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'promotor', width: null, sortable: true, sortFn: null },
                {
                    key: 'criado-em',
                    width: 150,
                    sortable: true,
                    sortFn: this.sortCriadoEm,
                },
                { key: 'situacao', width: 80, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            delete: null,
            debouncedOnSearch: null,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
        };
    },
    created() {
        this.rotaAninhada = this.$route.name.includes('rota') && this.$route.name != 'rota-list';

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'rotas');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'routes' },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        promptChangeSituacao(row) {
            this.delete = row;
            if (row.usuariosinrotas > 0 && row.situacao == 0) {
                this.$root.showMessage('alert', 'msg-usuario-rota');
                return;
            }
            if (row.inativos > 0 && row.situacao == 0) {
                this.$root.showMessage('alert', 'msg-registros-inativos-rotas-ativar');
            } else {
                let message = this.$t(
                        row.situacao == 1
                            ? 'msg-confirmacao-desativacao-n'
                            : 'msg-confirmacao-reativacao-n', 
                        { n: row['titulo-da-rota'] }
                    );
                this.$root.confirm({
                    message: message,
                    onConfirm: this.updateSituacaoRegistro,
                    onCancel: this.removePrompt,
                });
            }
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-desativar-rota'
                    : 'msg-erro-ao-reativar-rota';

            let tempRota = {
                idrota: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempRota)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-rota'
                                : 'msg-sucesso-ao-desativar-rota';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        toggle(row) {
            this.$refs.table.toggleDetails(row);
        },
        onSearch(value) {
            this.searchQuery = this.removeAcentos(value);
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.searchQuery
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allrotas = value;
                    this.isEmpty = this.allrotas.length <= 0;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(situacao) {
            this.situacao = situacao;
            this.carregarDados();
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let rotaslist = [];
            if (body.content) {
                rotaslist = body.content.map((r) => {
                    return {
                        id: r.idrota,
                        codigo: r.idrotaerp,
                        promotor: r.usuario ? r.usuario.nome : null,
                        'titulo-da-rota': r.descricao,
                        'criado-em': r.datahorainc,
                        excluir: 'excluir',
                        situacao: r.situacao,
                        inativos: r.inativos,
                        usuariosinrotas: r.usuariosinrotas,
                    };
                });
            }
            return rotaslist;
        },
        updateSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        parseDateString(d) {
            let a = d.split('T')[0].split('-');
            return new Date(a[0], a[1] - 1, a[2]).toLocaleDateString();
        },
        sortCriadoEm(a, b, isAsc) {
            let da = a['criado-em'].split('/').reverse().join('-');
            let db = b['criado-em'].split('/').reverse().join('-');

            if (isAsc) {
                return new Date(da).getTime() - new Date(db).getTime();
            } else {
                return new Date(db).getTime() - new Date(da).getTime();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        .situacao-select div {
            height: 40px;
        }
    }
}
</style>
